module.exports = __webpack_public_path__ + "static/media/nurse_accredited3.12a25147.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nurse_accredited3.png
// module id = 482
// module chunks = 0